import { render } from "./TransferServer.vue?vue&type=template&id=6f146fb2&scoped=true"
import script from "./TransferServer.vue?vue&type=script&lang=js"
export * from "./TransferServer.vue?vue&type=script&lang=js"

import "./TransferServer.vue?vue&type=style&index=0&id=6f146fb2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f146fb2"]])

export default __exports__